__turbopack_context__.v({
  "content": "style-module-scss-module__lAKShG__content",
});
